import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import close from '../gui/icon--close.svg';

import styles from './downloadAlert.css';

class DownloadAlert extends React.Component {
    constructor(props) {
        super()
    }
    render() {
        const {
            closeAlert,
            downloadConfig,
            Enter,
            Leave,
            clickOk,
            intl,
            setQuestion
        } = this.props

        // downloadConfig   参数说明
        // 全局的downloadAlert()，可在任意地方调用

        //调用方式
        // downloadAlert({
        //     show: true
        //     type:'Info',
        //     animation:true,
        //     content:'内容',
        //     isCloseBtn: true
        // })

        //参数说明
        // show         bool      是否显示
        // type         string    提示的类型 ‘Info’、‘Error’ info是蓝色提示框，Error是警告红色提示框
        // animation    bool      是否要动画效果
        // title        string    提示标题
        // content      string    提示内容
        // duration     number    设置延时关闭提示框
        // isCloseBtn   bool      是否在左上角显示关闭按钮
        // isOk         bool      是否显示确认按钮
        // clickOk      func      点击确认执行的函数，不写默认执行关闭窗口
        // showBg       bool      是否显示背景

        return (
            <div className={classnames(styles.donwload,
                { [styles.showbg]: downloadConfig.showBg }
            )}>
                <div className={classnames(styles.donwloadBox,
                    { [styles.animationAlert]: downloadConfig.animation },
                    { [styles[`Alert${downloadConfig.type}`]]: downloadConfig.type != undefined }
                )}
                    onMouseEnter={Enter}
                    onMouseLeave={Leave}
                >
                    {/* 关闭按钮 */}
                    {downloadConfig.isCloseBtn ? <span className={styles.closeAlert} onClick={closeAlert}>
                        <img src={close} width="100%" alt="" />
                    </span> : null}

                    {/* 标题 */}
                    {downloadConfig.title ? <span className={styles.downloadTitle}>
                        {downloadConfig.title}
                    </span> : null}

                    {/* 提示内容 */}
                    <p className={styles.donwloadContent}>
                        {downloadConfig.content}
                    </p>

                    {/* 确认按钮 */}
                    {downloadConfig.isOk ? <div className={styles.downloadOk}>
                        <span onClick={clickOk}>
                            {intl.formatMessage({
                                id: 'gui.gui.OK',
                                defaultMessage: 'OK'
                            })}
                        </span>
                    </div> : null}
                    {downloadConfig.type == "Error" ? <div className={styles.linkBox}>
                        <span className={styles.link} onClick={() => { setQuestion(true) }}>
                            {intl.formatMessage({
                                id: 'gui.importInfo.previewfaqlinktext',
                                defaultMessage: '常见问题'
                            })}？
                        </span>
                    </div> : null}
                </div>
            </div>
        )
    }
}

DownloadAlert.propTypes = {
    closeAlert: PropTypes.func,
    downloadConfig: PropTypes.shape({
        show: PropTypes.bool,
        type: PropTypes.string,
        animation: PropTypes.bool,
        title: PropTypes.string,
        content: PropTypes.string,
        duration: PropTypes.number,
        isCloseBtn: PropTypes.bool,
        isOk: PropTypes.bool,
        clickOk: PropTypes.func
    }),
    Enter: PropTypes.func,
    Leave: PropTypes.func
}

export default DownloadAlert